import {secureDownload, secureFetch} from "./authService";
import {API_BASE_URL, API_UPLOAD_URL, PAGINATION_DEFAULT_LIMIT} from "./constants";

export function getStores(query) {
	// let url = API_BASE_URL + `/retail/salesPoints?companyId=${query.companyId}`;
	// if (query.limit || query.page) {
	// 	url = API_BASE_URL + `/retail/salesPoints?companyId=${query.companyId}&limit=${query.limit || PAGINATION_DEFAULT_LIMIT}&page=${query.page || 0}`;
	// }
	// return secureFetch(url, {
	// 	method: 'GET'
	// });
    let url = API_BASE_URL + `/retail/salesPoints?`;

    if (query) {
        const {companyId, page = 0, filters, limit = PAGINATION_DEFAULT_LIMIT, sorting} = query;
        if (companyId) {
            url = url + `&companyId=${companyId}`;
        }

        if (limit) {
            url = url + `&limit=${limit}`;
        }

        if (page || page === 0) {
            url = url + `&page=${page}`;
        }

        if (filters && filters.length) {
            filters.forEach(filter => {
                if (filter.value) {
                    url = url + `&${filter.name}=${filter.value}`;
                }
            });
        }

        if (sorting) {
            url = url + `&sortField=${sorting.id}&sort=${sorting.desc ? 'ASC' : 'DESC'}`;
        }

    }
    return secureFetch(url, {
        method: 'GET'
    });
}

export function addStore(store) {
	return secureFetch(API_BASE_URL + '/retail/salesPoints', {
		method: 'POST',
		body: JSON.stringify(store)
	});
}

export function updateStore(store) {
	return secureFetch(API_BASE_URL + '/retail/salesPoints', {
		method: 'PUT',
		body: JSON.stringify(store)
	});
}

export function deleteStore(store) {
	return secureFetch(API_BASE_URL + '/retail/salesPoints/' + store.id, {
		method: 'DELETE'
	});
}

export function getTinyStores(query) {
    let url = API_BASE_URL + `/retail/salesPoints/tiny?`;
    if (query) {
        const {companyIds} = query;
        if (companyIds)
            url = url + `&companyIds=${companyIds.join()}`;
    }
    return secureFetch(url, {
        method: 'GET'
    });
}

export function getTinyStoresWithOperator(operatorId) {
    let url = API_BASE_URL + `/retail/salesPoints/tiny/withOperator?`;
    if (operatorId) {
        url = url + `&operatorId=${operatorId}`;
    }
    return secureFetch(url, {
        method: 'GET'
    });
}

export function getTinyStoresWithOperatorCsv(operatorId) {
    let url = API_BASE_URL + `/retail/salesPoints/tiny/withOperator/csv?`;
    if (operatorId) {
        url = url + `&operatorId=${operatorId}`;
    }
    return secureDownload(url, {
        method: 'GET'
    });
}

export function updateStoresByCsv(data) {
    return secureFetch(API_UPLOAD_URL + '/retail/salesPoints/csv', {
        method: 'PUT',
        body: data
    }, {});
}


// WEBPACK FOOTER //
// ./src/helpers/storeService.js